import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AUTH_QUERY_KEYS, AUTH_ROUTES } from '../constants';
import type { LoginFormValues } from '../schemas';
import { authService } from '../services';
import { useAuthStore } from './use-auth-store';

/** Mutation de login: autentica, atualiza a store e redireciona. */
export function useLogin() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (values: LoginFormValues) =>
      authService.login({
        email: values.email,
        password: values.password,
        rememberMe: values.rememberMe,
      }),

    onSuccess: async (data) => {
      setUser(data.user);
      await queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEYS.me });
      navigate(AUTH_ROUTES.DASHBOARD, { replace: true });
    },
  });
}
